<template>
  <div class="mb-5" :class="{blur:!loaded}">
    <invoice-modal
            v-if="project"
            :timelogs="optional(project, 'timeLogs.data', [])"
            :expenses="optional(project, 'expenses.data', [])"
            :milestones="milestones"
            :project="project"
            :visible="visible"
            @cancel="cancelGenerateInvoice"
    ></invoice-modal>
    <div class="rt">
      <div class="card w-60 pl-3 pt-3 card-p-active">
        <h6 class="text-bold text-opacity-pale">Expected Revenue 
          <span v-b-tooltip.hover
              :title="'The Amount that should be realized from the project. If this is an hourly project, the Estimated hours times the rate, regardless of discounts on Invoices. If this is a Milestone Project, the total combined value of the Milestones. If Total Project Value, the Total Value.'"
          ><i class="zmdi zmdi-info"></i></span>
        </h6>
        <div class="pt-1 pb-3">
          <h6
            class="h7 pt-1"
          >{{project.currency && project.currency.symbol}}{{parseFloat(project.projected_revenue).toFixed(2)}}</h6>
        </div>
      </div>

      <div class="card w-60 pl-3 pt-3">
        <h6 class="text-bold text-opacity-pale">Project Revenue
          <span v-b-tooltip.hover
              :title="'The amounts received for the project from manually/ automatically recorded payments.'"
          ><i class="zmdi zmdi-info"></i></span>
        </h6>
        <div class="pt-1 pb-3">
          <h6
            class="h7 pt-1"
          >{{project.currency && project.currency.symbol}}{{parseFloat(project.revenue).toFixed(2)}}</h6>
        </div>
      </div>

      <div class="card w-60 pl-3 pt-3">
        <h6 class="text-bold text-opacity-pale">Total project cost
          <span v-b-tooltip.hover
              :title="'The cost incurred from all logged time and expenses.'"
          ><i class="zmdi zmdi-info"></i></span>
        </h6>
        <div class="pt-1 pb-3">
          <h6
            class="h7 pt-1"
          >{{project.currency && project.currency.symbol}}{{parseFloat(project.actual_cost).toFixed(2)}}</h6>
        </div>
      </div>

      <div class="card w-60 pl-3 pt-3">
        <h6 class="text-bold text-opacity-pale">Total project expenses
          <span v-b-tooltip.hover
              :title="'The total amount from all related Expenses.'"
          ><i class="zmdi zmdi-info"></i></span>
        </h6>
        <div class="pt-1 pb-3">
          <h6
            class="h7 pt-1"
          >{{project.currency && project.currency.symbol}}{{parseFloat(project.total_expenses).toFixed(2)}}</h6>
        </div>
      </div>
      <div class="card w-60 pl-3 pt-3">
        <h6 class="text-bold text-opacity-pale">Project Profit/Loss
          <span v-b-tooltip.hover
              :title="'The realized project revenue less cost and expenses.'"
          ><i class="zmdi zmdi-info"></i></span>
        </h6>
        <div class="pt-1 pb-3">
          <h6 class="h7 pt-1">{{project.currency && project.currency.symbol}}{{profitLoss}}</h6>
        </div>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-sm-12 col-lg-2">
        <div class="card w-60 pl-3 pt-3 card-p-active">
          <h6 class="text-bold text-opacity-pale">Expected Revenue</h6>
          <div class="pt-1 pb-3">
            <h6
              class="h7 pt-1"
            >{{project.currency && project.currency.symbol}}{{project.revenue ? project.revenue : '0'}}</h6>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-lg-2">
        <div class="card w-60 pl-3 pt-3 card-p-active">
          <h6 class="text-bold text-opacity-pale">Project Revenue</h6>
          <div class="pt-1 pb-3">
            <h6
              class="h7 pt-1"
            >{{project.currency && project.currency.symbol}}{{project.revenue ? project.revenue : '0'}}</h6>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-lg-2">
        <div class="card w-60 pl-3 pt-3">
          <h6 class="text-bold text-opacity-pale">Total project cost</h6>
          <div class="pt-1 pb-3">
            <h6
              class="h7 pt-1"
            >{{project.currency && project.currency.symbol}}{{project.actual_cost ? project.actual_cost : '0'}}</h6>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-lg-2">
        <div class="card w-60 pl-3 pt-3">
          <h6 class="text-bold text-opacity-pale">Total project expenses</h6>
          <div class="pt-1 pb-3">
            <h6
              class="h7 pt-1"
            >{{project.currency && project.currency.symbol}}{{project.total_expenses ? project.total_expenses : '0'}}</h6>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-lg-2">
        <div class="card w-60 pl-3 pt-3">
          <h6 class="text-bold text-opacity-pale">Project P/L</h6>
          <div class="pt-1 pb-3">
            <h6 class="h7 pt-1">{{project.currency && project.currency.symbol}}{{profit_loss}}</h6>
          </div>
        </div>
      </div>
    </div>-->
    <!-- new row -->
    <div class="mt-4 row">
      <div class="col-sm-12 col-lg-3">
        <div class="row">
          <div class="col-sm-12">
            <div class="card w-70">
              <div class="card-header no-right-padding-card">
                Project Details
                <span class="btn-icon-sm float-right">
                  <svg
                    width="20"
                    height="20"
                    fill="#72809D"
                    viewBox="0 0 30 30"
                    xmlns="http://www.w3.org/2000/svg"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                  >
                    <path
                      d="M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z"
                    ></path>
                  </svg>
                </span>
                <router-link :to="{name: 'projects-edit'}">
                  <span class="btn-icon-sm float-right">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="#72809D"
                      viewBox="0 0 30 30"
                    >
                      <path
                        d="M14.078 4.232l-12.64 12.639-1.438 7.129 7.127-1.438 12.641-12.64-5.69-5.69zm-10.369 14.893l-.85-.85 11.141-11.125.849.849-11.14 11.126zm2.008 2.008l-.85-.85 11.141-11.125.85.85-11.141 11.125zm18.283-15.444l-2.816 2.818-5.691-5.691 2.816-2.816 5.691 5.689z"
                      ></path>
                    </svg>
                  </span>
                </router-link>
              </div>
              <div class="card-content p-3">
                <div class="row">
                  <div class="col-sm-6">Project type:</div>
                  <div
                    class="col-sm-6 float-right text-right"
                  >{{project.billingType && project.billingType.name}}</div>
                </div>
                <div class="row mt-3">
                  <div class="col-sm-6">Project rate:</div>
                  <div
                    class="col-sm-6 float-right text-right"
                  >{{project.currency && project.currency.symbol}} {{project.hourly_rate}} </div>
                </div>
                <div class="row mt-3">
                  <div class="col-sm-6">Estimated duration:</div>
                  <div class="col-sm-6 float-right text-right">{{project.estimated_hours}} hrs</div>
                </div>
                <div class="row mt-3">
                  <div class="col-sm-6">Time Cap:</div>
                  <div class="col-sm-6 float-right text-right">{{project.hourly_cap}} hrs</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 mt-4">
            <div class="card w-70">
              <div class="card-header">
                REVENUE
                <a class="float-right" style="text-transform:none !important" href="#">
                  Go to Invoices
                  <i style="font-size:15px" class="zmdi pl-2 zmdi-chevron-right"></i>
                </a>
              </div>
              <div class="card-content p-3">
                <div class="row card-border-between">
                  <div class="col-sm-4 list">
                    <h5>{{optional(project, 'currency.symbol', 'N/A' )}} {{ optional(invoicesTotal, 'meta.meta.totalDue', 0 ) }} </h5>
                    <h6 style="font-size:11px !important;" class="text-opacity">Due</h6>
                  </div>
                  <div class="col-sm-4 list">
                    <h5
                      class="text-lightblue"
                    >{{optional(project, 'currency.symbol', 'N/A' )}} {{ optional(invoicesTotal, 'meta.meta.totalBilled', 0 ) }}</h5>
                    <h6 style="font-size:11px !important;" class="text-opacity">Billed for</h6>
                  </div>
                  <div class="col-sm-4 list">
                    <h5 class="text-lemon">{{optional(project, 'currency.symbol', 'N/A' )}} {{ optional(invoicesTotal, 'meta.meta.totalPaid', 0 ) }}</h5>
                    <h6 style="font-size:11px !important;" class="text-opacity">Paid for</h6>
                  </div>
                </div>
                <!-- <div class="row card-border-top">
                  <div :key="index" v-for="(milestone,index) of milestones" class="col-sm-12 list">
                    <div class="row mt-3">
                      <div class="col-sm-6">
                        <h6 class="h8">{{milestone.name}}</h6>
                        <h6 class="text-opacity h10">{{milestone.description}}</h6>
                      </div>
                      <div class="col-sm-6 float-right text-right">{{milestone.status.name}}</div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-lg-9">
        <div class="row">
          <div class="col-sm-12">
            <div class="card w-70 full-width">
              <div class="card-header">
                REVENUE BREAKDOWN
                <span @click="generateInvoice" class="btn-text float-right">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8 24l2.674-9h-9.674l16-15-2.674 9h8.674l-15 15zm-1.586-11h6.912l-1.326 4 5.739-6h-6.065l1.304-4-6.564 6z"
                      ></path>
                    </svg>
                  </span>
                  Generate Invoice
                </span>
              </div>
              <div class="card-stats">
                <div class="row">
                  <div class="col-sm-12 col-lg-6 pl-5 pr-4 pt-3 pb-3">
                    <ul class="card-stats__list">
                      <li class="w--25">
                        <span>
                          <small class="text-opacity-pale">Total Entries</small>
                        </span>
                        <span>
                          <h6>{{optional(invoicesTotal, 'meta.meta.pagination.total', 0) }} entries</h6>
                        </span>
                      </li>
                      <li class="w--25">
                        <span>
                          <small class="text-opacity-pale">Total Amount</small>
                        </span>
                        <span>
                          <h6>{{optional(project, 'currency.symbol', 'N/A')}} {{optional(invoicesTotal, 'meta.meta.totalAmount', '0')}} </h6>
                        </span>
                      </li>
                      <li class="w--25">
                        <span>
                          <small class="text-opacity-pale">Billed For</small>
                        </span>
                        <span>
                          <h6 class="text-lightblue"> {{optional(project, 'currency.symbol', 'N/A' )}} {{optional(invoicesTotal, 'meta.meta.totalBilled', '0' )}} </h6>
                        </span>
                      </li>
                      <li class="w--25">
                        <span>
                          <small class="text-opacity-pale">Paid For</small>
                        </span>
                        <span>
                          <h6 class="text-lemon"> {{optional(project, 'currency.symbol', 'N/A' )}} {{optional(invoicesTotal, 'meta.meta.totalPaid', '0' )}} </h6>
                          </span>
                      </li>
                    </ul>
                  </div>
                  <div class="col-sm-12 col-lg-6 pl-5 pt-1">
                    <div>
                      <small class="text-opacity text-right">Filters</small>
                      <div>
                        <form class="d-form">
                          <div class="d-form__filters">
                            <div class="li date-range">
                              <vc-date-picker
                                :masks="{ input: ['YYYY-MM-DD']}"
                                :input-props="{class:`d-input no-margin-top auth-input pl-3`,style: `margin-top:0px !important;width:150px`,placeholder: `Start date`}"
                                name="start_date"
                                ref="startFrom"
                                :value="null"
                                data-vv-as="Project Start date"
                              />
                            </div>
                            <div class="li date-range">
                              <vc-date-picker
                                :masks="{ input: ['YYYY-MM-DD']}"
                                :input-props="{class:`d-input no-margin-top auth-input pl-3`,style: `margin-top:0px !important; width:150px`,placeholder: `End date`}"
                                name="start_date"
                                ref="startFrom"
                                :value="null"
                                data-vv-as="Project Start date"
                              />
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-content">
                <revenue-break-down
                  :id="this.$route.params.id"
                  :moreParams="tableFilters.invoicesParams"
                  @getInvoiceTotal="setInvoiceMeta"
                  :project_type="project.billing_type && project.billing_type.name"
                ></revenue-break-down>
              </div>
            </div>
          </div>
          <div class="col-sm-12 mt-3">
            <div class="card w-70 full-width">
              <div class="card-header no-right-padding-card">
                HOURS LOGGED
                <span class="btn-icon-sm float-right">
                  <svg
                    width="20"
                    height="20"
                    fill="#72809D"
                    viewBox="0 0 30 30"
                    xmlns="http://www.w3.org/2000/svg"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                  >
                    <path
                      d="M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z"
                    ></path>
                  </svg>
                </span>
              </div>
              <div class="card-stats">
                <div class="row">
                  <div class="col-sm-12 col-lg-6 pl-5 pr-4 pt-3 pb-3">
                    <ul class="card-stats__list">
                      <li class="w--25">
                        <span>
                          <small class="text-opacity-pale">Total Entries</small>
                        </span>
                        <span>
                          <h6>{{optional(hoursLoggedTotal, 'meta.meta.pagination.total', 0 )}} entries</h6>
                        </span>
                      </li>
                      <li class="w--25">
                        <span>
                          <small class="text-opacity-pale">Hours Logged</small>
                        </span>
                        <span>
                          <h6>{{optional(hoursLoggedTotal, 'meta.meta.totalHours', 0 )}} hrs</h6>
                        </span>
                      </li>
                      <li class="w--25">
                        <span>
                          <small class="text-opacity-pale">Total Cost</small>
                        </span>
                        <span>
                          <h6>{{optional(project, 'currency.symbol', 'N/A') }} {{ optional( hoursLoggedTotal, 'meta.meta.totalCost', 0)}}</h6>
                        </span>
                      </li>
                      <li class="w--25">
                        <span>
                          <small class="text-opacity-pale">Total Revenue</small>
                        </span>
                        <span>
                          <h6>{{optional(project, 'currency.symbol', 'N/A') }}  {{ optional( hoursLoggedTotal, 'meta.meta.totalBilledCost', 0)}}</h6>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div class="col-sm--12 col-lg-6 pl-5 pt-1">
                    <div>
                      <small class="text-opacity">Filters</small>
                      <div>
                        <form class="d-form">
                          <div class="d-form__filters">
                            <div class="li date-range">
                              <vc-date-picker
                                :masks="{ input: ['YYYY-MM-DD']}"
                                :input-props="{class:`d-input no-margin-top auth-input pl-3`,style: `margin-top:0px !important`,placeholder: `Start date`}"
                                name="start_date"
                                ref="startFrom"
                                :value="null"
                                data-vv-as="Project Start date"
                              />
                            </div>
                            <div class="li date-range">
                              <vc-date-picker
                                :masks="{ input: ['YYYY-MM-DD']}"
                                :input-props="{class:`d-input no-margin-top auth-input pl-3`,style: `margin-top:0px !important`,placeholder: `End date`}"
                                name="start_date"
                                ref="startFrom"
                                :value="null"
                                data-vv-as="Project Start date"
                              />
                            </div>
                            <div class="li">
                              <multiselect
                                track-by="id"
                                return="id"
                                label="name"
                                class="no-inline-select"
                                v-validate="'required'"
                                name="project_status_id"
                                @input="setExpenseFilter(tableFilters.hoursLoggedParams)"
                                v-model="tableFilters.hoursLoggedParams.employee"
                                :options="collaborators"
                                :show-labels="false"
                                placeholder="Employee"
                                data-vv-as="Project Status"
                              >
                                <template
                                  slot="option"
                                  slot-scope="{option}"
                                >{{ option.first_name }} {{ option.last_name }}</template>
                                <template
                                  slot="singleLabel"
                                  slot-scope="{option}"
                                >{{ option.first_name }} {{ option.last_name }}</template>
                              </multiselect>
                            </div>
                            <div class="li pt-2 pl-2">
                              <input
                                v-model="tableFilters.hoursLoggedParams.is_billable"
                                @change="setExpenseFilter(tableFilters.hoursLoggedParams)"
                                type="checkbox"
                                id="billable"
                                value="1"
                              >
                              <label for="billable" class="pl-2">
                                <h6 class="h7">Is Billable?</h6>
                              </label>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-content">
                <hourly-table
                  :moreParams="tableFilters.hoursLoggedParams"
                  :api="hoursLoggedApi"
                  @getHoursLogged="setTimeLoggedMeta"
                ></hourly-table>
              </div>
            </div>
          </div>
          <div class="col-sm-12 mt-3">
            <div class="card w-70 full-width">
              <div class="card-header no-right-padding-card">
                PROJECT MILESTONES
                <span class="btn-icon-sm float-right">
                  <svg
                    width="20"
                    height="20"
                    fill="#72809D"
                    viewBox="0 0 30 30"
                    xmlns="http://www.w3.org/2000/svg"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                  >
                    <path
                      d="M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z"
                    ></path>
                  </svg>
                </span>
              </div>
              <div class="card-stats">
                <div class="row">
                  <div class="col-sm-12 col-lg-5 pl-5 pr-4 pt-3 pb-3">
                    <ul class="card-stats__list">
                      <li class="w--50">
                        <span>
                          <small class="text-opacity-pale">Total Entries</small>
                        </span>
                        <span>
                          <h6>{{milesStoneTotal.meta && milesStoneTotal.meta.meta && milesStoneTotal.meta.meta.pagination.total ? milesStoneTotal.meta.meta.pagination.total : 0}} entries</h6>
                        </span>
                      </li>
                      <li class="w--50">
                        <span>
                          <small class="text-opacity-pale">Total Amount</small>
                        </span>
                        <span>
                          <h6>{{project && project.currency && project.currency.symbol}} {{milesStoneTotal.meta && milesStoneTotal.meta.meta && milesStoneTotal.meta.meta.totalCost ? milesStoneTotal.meta.meta.totalCost : 0}}</h6>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div class="col-sm--12 col-lg-7 pl-5 pt-1">
                    <div>
                      <small class="text-opacity">Filters</small>
                      <div>
                        <form class="d-form">
                          <div class="d-form__filters">
                            <div class="li date-range">
                              <vc-date-picker
                                :masks="{ input: ['YYYY-MM-DD']}"
                                :input-props="{class:`d-input no-margin-top auth-input pl-3`,style: `margin-top:0px !important`,placeholder: `Start date`}"
                                name="start_date"
                                ref="startFrom"
                                :value="null"
                                data-vv-as="Project Start date"
                              />
                            </div>
                            <div class="li date-range">
                              <vc-date-picker
                                :masks="{ input: ['YYYY-MM-DD']}"
                                :input-props="{class:`d-input no-margin-top auth-input pl-3`,style: `margin-top:0px !important`,placeholder: `End date`}"
                                name="start_date"
                                ref="startFrom"
                                :value="null"
                                data-vv-as="Project Start date"
                              />
                            </div>
                            <div class="li">
                              <multiselect
                                track-by="id"
                                return="name"
                                label="name"
                                @input="setExpenseFilter(tableFilters.milestoneParams)"
                                class="no-inline-select"
                                v-validate="'required'"
                                name="project_status_id"
                                :options="collaborators"
                                v-model="tableFilters.milestoneParams.employee"
                                :show-labels="false"
                                placeholder="Employee"
                                data-vv-as="Project Status"
                              >
                                <template
                                  slot="option"
                                  slot-scope="{option}"
                                >{{ option.first_name }} {{ option.last_name }}</template>
                                <template
                                  slot="singleLabel"
                                  slot-scope="{option}"
                                >{{ option.first_name }} {{ option.last_name }}</template>
                              </multiselect>
                            </div>
                            <div class="li pt-2 pl-2">
                              <input
                                v-model="tableFilters.milestoneParams.is_billable"
                                @change="setExpenseFilter(tableFilters.milestoneParams)"
                                type="checkbox"
                                id="billable"
                              >
                              <label for="billable" class="pl-2">
                                <h6 class="h7">Is Billable?</h6>
                              </label>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-content">
                <milestone-table
                  :api="mileStoneApi"
                  :moreParams="tableFilters.milestoneParams"
                  @getMilestoneTotal="setMileStoneMeta"
                ></milestone-table>
              </div>
            </div>
          </div>
          <div class="col-sm-12 mt-3">
            <div class="card w-70 full-width">
              <div class="card-header">
                PROJECT EXPENSES
                <span class="float-right btn-icon-sm">
                  <svg
                    width="20"
                    height="20"
                    fill="#72809D"
                    viewBox="0 0 30 30"
                    xmlns="http://www.w3.org/2000/svg"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                  >
                    <path
                      d="M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z"
                    ></path>
                  </svg>
                </span>
              </div>
              <div class="card-stats">
                <div class="row">
                  <div class="col-sm-12 col-lg-4 pl-5 pr-4 pt-3 pb-3">
                    <ul class="card-stats__list">
                      <li class="w--50">
                        <span>
                          <small class="text-opacity-pale">Total Entries</small>
                        </span>
                        <span>
                          <h6>{{expensesTotal.meta && expensesTotal.meta.meta && expensesTotal.meta.meta && expensesTotal.meta.meta.pagination.total ? expensesTotal.meta.meta.pagination.total : 0}} {{'entries'}}</h6>
                        </span>
                      </li>
                      <li class="w--50">
                        <span>
                          <small class="text-opacity-pale">Total Expenses</small>
                        </span>
                        <span>
                          <h6>{{project && project.currency && project.currency.symbol}} {{expensesTotal.meta && expensesTotal.meta.meta && expensesTotal.meta.meta.totalAmount ? expensesTotal.meta.meta.totalAmount : 0}}</h6>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div class="col-sm-12 col-lg-8 pl-5 pt-1">
                    <div>
                      <small class="text-opacity">Filters</small>
                      <div>
                        <form class="d-form">
                          <div class="d-form__filters">
                            <div class="li date-range" style="max-width:100px">
                              <vc-date-picker
                                :masks="{ input: ['YYYY-MM-DD']}"
                                :input-props="{class:`d-input no-margin-top auth-input pl-3`,style: `margin-top:0px !important;`,placeholder: `Start date`}"
                                name="start_date"
                                value
                                ref="startFrom"
                                v-model="tableFilters.expensesParams.start_from"
                                data-vv-as="Project Start date"
                              />
                            </div>
                            <div class="li date-range" style="max-width:100px">
                              <vc-date-picker
                                :masks="{ input: ['YYYY-MM-DD']}"
                                :input-props="{class:`d-input no-margin-top auth-input pl-3`,style: `margin-top:0px !important;width:100px`,placeholder: `End date`}"
                                name="start_date"
                                ref="startFrom"
                                value
                                v-model="tableFilters.expensesParams.end_to"
                                data-vv-as="Project Start date"
                              />
                            </div>
                            <div class="li">
                              <multiselect
                                track-by="id"
                                return="id"
                                label="name"
                                @input="setExpenseFilter(tableFilters.expensesParams)"
                                class="no-inline-select"
                                v-validate="'required'"
                                name="project_status_id"
                                :options="collaborators"
                                v-model="tableFilters.expensesParams.employee"
                                :show-labels="false"
                                placeholder="Employee"
                                data-vv-as="Project Status"
                              >
                                <template
                                  slot="option"
                                  slot-scope="{option}"
                                >{{ option.first_name }} {{ option.last_name }}</template>
                                <template
                                  slot="singleLabel"
                                  slot-scope="{option}"
                                >{{ option.first_name }} {{ option.last_name }}</template>
                              </multiselect>
                            </div>
                            <div class="li pt-2 pl-2">
                              <input
                                @change="setExpenseFilter(tableFilters.expensesParams)"
                                type="checkbox"
                                id="billable"
                                v-model="tableFilters.expensesParams.is_reimbursed"
                              >
                              <label for="billable" class="pl-2">
                                <h6 class="h7">Is Reimbursable?</h6>
                              </label>
                            </div>
                            <div class="li pt-2 pl-2">
                              <input
                                @change="setExpenseFilter(tableFilters.expensesParams)"
                                type="checkbox"
                                id="billable"
                                v-model="tableFilters.expensesParams.is_billable"
                              >
                              <label for="billable" class="pl-2">
                                <h6 class="h7">Is Billable?</h6>
                              </label>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-content">
                <!-- {{Object.keys(tableFilters.expensesParams)}} -->
                <expenses-table
                  :api="api"
                  :moreParams="tableFilters.expensesParams"
                  @setExpenseFilter="setExpenseFilter"
                  @getExpensesMeta="setExpensesMeta"
                ></expenses-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
  </div>
</template>

<style lang="scss" scoped>
.rt {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  .card {
    flex-basis: 100%;
    // margin-right: 10px;
    &:not(:last-child) {
      margin-right: 10px;
    }
  }
  @media (max-width: 576px) {
    flex-wrap: wrap !important;

    .card {
      margin-top: 10px !important;
    }
  }
}
</style>

<script>
import ExpensesTable from "@/components/Tables/Expenses/Index";
import HourlyTable from "@/components/Tables/Projects/Revenue-BreakDown/Hourly";
import MilestoneTable from "@/components/Tables/Projects/Revenue-BreakDown/Milestone";
import RevenueBreakDown from "@/components/Tables/Projects/Revenue-BreakDown/Index";
import InvoiceModal from "@/components/Modals/Invoice";
import moment from "moment";
import {optional} from "@/helpers/random";

export default {
  components: {
    ExpensesTable,
    RevenueBreakDown,
    HourlyTable,
    InvoiceModal,
    MilestoneTable
  },
  data() {
    return {
      milestone_acc: false,
      accordions: [
        { name: "project", visible: true },
        { name: "milestone", visible: false },
        { name: "tasks", visible: false },
        { name: "timetracking", visible: false },
        { name: "additional", visible: false }
      ],
      table_data: [
        { name: "expenses", meta: "" },
        { name: "time_logs", meta: "" },
        { name: "milestone", meta: "" },
        { name: "invoices", meta: "" }
      ],
      visible: false,
      tableFilters: {
        expensesParams: {
          include: "project,task,category",
          per_page: 20,
          is_reimbursed: 1,
          end_to: null,
          start_from: null
        },
        milestoneParams: {
          include: "project,task,category",
          per_page: 20,
          is_billable: 1,
          end_to: null,
          start_from: null
        },
        hoursLoggedParams: {
          include: "project,task,category,employee",
          per_page: 10,
          is_billable: 1,
          end_to: null,
          start_from: null
        },
        invoicesParams: {
          include: "project,task,category,employee",
          per_page: 10,
          is_billable: 1,
          end_to: null,
          start_from: null
        }
      },
      loaded: false
    };
  },
  computed: {
    project() {
      return this.$store.getters["projects/project"];
    },
    collaborators() {
      return this.$store.getters["projects/collaborators_simple"];
    },
    api() {
      return `${this.$baseApi}/projects/${
        this.$route.params.id
      }/expenses?include=category`;
    },
    expensesTotal() {
      return this.table_data.find(s => s.name == "expenses");
    },
    hoursLoggedTotal() {
      return this.table_data.find(s => s.name == "time_logs");
    },
    milesStoneTotal() {
      return this.table_data.find(s => s.name == "milestone");
    },
    invoicesTotal() {
      return this.table_data.find(s => s.name == "invoices");
    },
    hoursLoggedApi() {
      return `${this.$baseApi}/projects/${this.$route.params.id}/timelogs`;
    },
    mileStoneApi() {
      return `${this.$baseApi}/projects/${this.$route.params.id}/milestones`;
    },
    profitLoss() {
      // let expenses = parseFloat(this.project.total_expenses);
      // let revenue = parseFloat(this.project.revenue);

      return this.project.profit;
    },
    milestones() {
      return this.$store.getters["projects/milestones"];
    },
    invoices() {
      return this.optional(this.project, 'invoices.data', []);
    },
    invoicesBilled() {
      return this.invoices.reduce((t, s) => t + parseFloat(s.amount), 0);
    },
    invoicesPaid() {
      return this.invoices.reduce((t, s) => t + parseFloat(s.amount_paid), 0);
    },
    invoicesDue() {
      return this.invoices
        .filter(d => moment(d.due_date).isBefore(moment()))
        .reduce((t, s) => t + parseFloat(s.amount), 0);
    }
  },
  methods: {
    moment,
    optional,
    generateInvoice() {
      this.visible = true;
    },
    cancelGenerateInvoice() {
      this.visible = false;
    },
    setExpenseFilter(payload) {
      for (let [key, value] of Object.entries(payload)) {
        if (value !== 0 || !value || value === "") {
          delete payload[key];
        }
        else if (typeof value === "object") {
          //append id to params
          payload[key + "_id"] = value.id;
          // delete this.tableFilters.expensesParams[key];
        }
        else if (typeof value === "boolean") {
          payload[key] = value ? 1 : 0;
        }

      }
    },
    toggleCollapse(index) {
      this.accordions[index].visible =
        this.accordions[index].visible === false ? true : false;
    },
    setExpensesMeta(value) {
      let expense = this.table_data.find(s => s.name == "expenses");
      expense.meta = value;
    },
    setTimeLoggedMeta(value) {
      let timeLogged = this.table_data.find(s => s.name == "time_logs");
      timeLogged.meta = value;
    },
    setMileStoneMeta(value) {
      let milestone = this.table_data.find(s => s.name == "milestone");
      milestone.meta = value;
    },
    setInvoiceMeta(value) {
      let invoice = this.table_data.find(s => s.name == "invoices");
      invoice.meta = value;
    }
  },
  created() {
    Promise.all([
      this.$store.dispatch("projects/getSingle", this.$route.params.id),
      this.$store.dispatch("projects/getCollaborators", this.$route.params.id),
      this.$store.dispatch("projects/getMilestones", this.$route.params.id),
    ]).finally(() => {
      this.loaded = true;
    })
  }
};
</script>

